export const env = {
    api_domain: "https://staging.homeshark.com/api",
    domain: "https://staging.homeshark.com",
    production: true,
    staging: true,
    stripe_key:
        "pk_test_51Ro5ZHFo7zrBrXCfJD3iEY5BBVUyfGpceMsLoMcqgmcOkOWRLOdCP9WezxM23vH9GRAUQNZGaj3ZUwet23YMOJRW00yqoN0yaT",
    pricing_table_id: "prctbl_1TPqXgFo7zrBrXCf9EYWgOVb",
}
